import { put, select, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { UPDATE_TINT_SERVICE_IN_SERVICE_BASKET } from 'features/basket/ducks/actions';
import { getPriceOfTintService } from 'features/related-services';

/**
 * Событие должно срабатывать при добавлении в корзину товара с услугой колеровки
 *
 * @see https://tracker.yandex.ru/PCP-10342
 */

const commonParams = {
  elementType: 'button',
  elementBlock: 'productDetail',
  elementName: 'outstoreServices',
  productName: 'Услуга колеровки',
  productBelong: 'LeroyMerlinServices',
};

type TGaParams = {
  productId: string; // id услуги
  productPrice: string; // цена услуги
  productQuantity: string;
} & typeof commonParams;

export const gaAddTintServiceToCart = createAction('GA:addToCart')<
  {
    elementText: 'В корзину';
  } & TGaParams
>();

export const gaRemoveTintServiceFromCart = createAction('GA:removeFromCart')<
  {
    elementText: 'Удалить';
  } & TGaParams
>();

function* putGaUpdateTintServiceInCart({
  flowQty,
  serviceIdForTint,
}: {
  flowQty: number;
  serviceIdForTint: string;
}) {
  const tintServicePrice: string = yield select(getPriceOfTintService);

  const tintServiceParams = {
    productId: serviceIdForTint,
    productPrice: tintServicePrice.concat('.00'),
    productQuantity: Math.abs(flowQty).toString(),
  };

  if (flowQty >= 0) {
    yield put(
      gaAddTintServiceToCart({
        elementText: 'В корзину',
        ...commonParams,
        ...tintServiceParams,
      }),
    );
  } else {
    yield put(
      gaRemoveTintServiceFromCart({
        elementText: 'Удалить',
        ...commonParams,
        ...tintServiceParams,
      }),
    );
  }
}

export function* runGaUpdateTintServiceInCartDetector() {
  yield takeEvery(UPDATE_TINT_SERVICE_IN_SERVICE_BASKET, ({ payload }) =>
    putGaUpdateTintServiceInCart(payload),
  );
}
